var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import { useMemo } from "react";
import { css } from "styled-components";
import { get } from 'lodash';
export var useExtraStyles = function useExtraStyles(key, props) {
  var entity = props.entity;
  var options = entity && entity.options || {};
  return useMemo(function () {
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      ", "\n      ", "\n    "], ["\n      ", "\n      ", "\n    "])), get(props, key, ''), get(options, key, ''));
  }, [options]);
};
var templateObject_1;